import { WS_DATA, APP } from './app.constants';

export const EVENTS = `${APP}_events`;
export const CLOSE_EVENTS = `${EVENTS}/CLOSE_EVENTS`;
export const OPEN_EVENTS = `${EVENTS}/OPEN_EVENTS`;

export const WS_DATA_EVENT = `${WS_DATA}/event`;
export const WS_DATA_EVENTS = `${WS_DATA}/events`;